export const SET_DATA = '[CONTENT-FILTER] SET_DATA';
export const RESET_DATA = '[CONTENT-FILTER] RESET_DATA';
export const SET_SHOW_MORE = '[CONTENT-FILTER] SET_SHOW_MORE';
export const SET_FILTER = '[CONTENT-FILTER] SET_FILTER';
export const REMOVE_FILTER = '[CONTENT-FILTER] REMOVE_FILTER';

// import selectors
import { getContentType } from './ContentFilter.selectors';
import { getAllMakes } from '../makes/Makes.selectors';
import { getAllVideos } from '../videos/Videos.selectors';
import { getAllEntries } from '../gallery/Gallery.selectors';

const getData = (type, state) => {
  switch (type) {
    case 'makes':
      return getAllMakes(state);
    case 'videos':
      return getAllVideos(state);
    case 'gallery':
      return getAllEntries(state);
    default:
      return [];
  }
};

export const setData = (type) => {
  return (dispatch, getState) => {
    const state = getState();
    const currentDataType = getContentType(state);

    if (currentDataType !== type) {
      dispatch(resetData());
    }

    dispatch({
      type: SET_DATA,
      payload: {
        type,
        data: getData(type, state),
      },
    });
  };
};

export const resetData = () => ({
  type: RESET_DATA,
});

export const setShowMore = () => ({
  type: SET_SHOW_MORE,
});

export const setFilter = (filter) => ({
  type: SET_FILTER,
  payload: filter,
});

export const removeFilter = (filter) => ({
  type: REMOVE_FILTER,
  payload: filter,
});
